/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketssettingshintbuyer3Inputs */

const en_ticketssettingshintbuyer3 = /** @type {(inputs: Ticketssettingshintbuyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers pay the ticket fee`)
};

const de_ticketssettingshintbuyer3 = /** @type {(inputs: Ticketssettingshintbuyer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketgebühr zahlen Käufer`)
};

/**
* | output |
* | --- |
* | "Buyers pay the ticket fee" |
*
* @param {Ticketssettingshintbuyer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssettingshintbuyer3 = /** @type {((inputs?: Ticketssettingshintbuyer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssettingshintbuyer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssettingshintbuyer3(inputs)
	return de_ticketssettingshintbuyer3(inputs)
});
export { ticketssettingshintbuyer3 as "ticketsSettingsHintBuyer" }